import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../common/GridLayout";
import {AllowedPageSizes} from '../../../../../const/constants';
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    Lookup,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
const cariers = [
    { id: 'Y', name: 'Yes' },
    { id: 'N', name: 'No' },
    { id: 'S', name: 'Sent' },
    { id: 'A', name: 'Accepted' },
    { id: 'R', name: 'Rejected' },
];
const HistoryTransaction = (props) => {
    const dataGrid = useRef(null);
    const cariers = [
        { id: 'Y', name: 'Yes' },
        { id: 'N', name: 'No' },
        { id: 'S', name: 'Sent' },
        { id: 'A', name: 'Accepted' },
        { id: 'R', name: 'Rejected' },
    ];
    const modes = [
        { id: 'T', name: 'Company Truck' },
        { id: 'S', name: 'Outside Truck' },
        { id: 'A', name: 'Air' },
        { id: 'R', name: 'Rail' },
        { id: 'O', name: 'Ocean' },
        { id: 'B', name: 'Barge' },
        { id: 'L', name: 'Less Than Truck Load' },
        { id: 'P', name: 'Customer Pickup' },
        { id: 'C', name: 'Container' },
    ];
    const transTypes = [
        { id: 'S', name: 'Shipment' },
        { id: 'R', name: 'Receipt' },
        { id: 'C', name: 'Storage' },
        { id: 'A', name: 'Adjustment' },
        { id: 'M', name: 'Miscellaneous' }
    ];

    var accessToken = props.oidc.user.access_token;
    const childRef = useRef();
    
    const gridKey = "89A5925C-6C05-43C6-9569-80D1990837F4";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const onSelectionChanged = ({ selectedRowsData }) => {
        const selectedRowData = selectedRowsData[0];
        if (childRef.current) {
            childRef.current.updateData(selectedRowData);
        }
    };

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                style={{ height: '100%', minHeight: 0 }}
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <ColumnHeaderFilter />
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={25} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={AllowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={false} />
                <FilterPanel visible={false} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
              
                <Scrolling mode="virtual" />
                <Column dataField="record" caption="Record#"  />
                <Column dataField="customerIdentityId" caption="Customer" />
                <Column dataField="customerName" caption="Customer Name" />
                <Column dataField="transactionType" caption="Transaction Type" />
                <Column dataField="transactionNumber" caption="Transaction#" />
                <Column dataField="transactionDate" caption="Transaction Date" dataType="date" format="MM/dd/yyyy" />
                <Column dataField="stagingStartDate" caption="Staging Start Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="shipper" caption="Shipper#" />
                <Column dataField="status" caption="Status" />
                <Column dataField="stage" caption="Stage" />
                <Column dataField="transportationMode" caption="Mode"/>
                <Column dataField="equipmentType" caption="Equipment Type" visible={false} />
                <Column dataField="shipperName" caption="Shipper Name" visible={false} />
                <Column dataField="consignee" caption="Consignee" visible={false} />
                <Column dataField="consigneeName" caption="Consignee Name" visible={false} />
                <Column dataField="shipperBolNumber" caption="Shipper BOL Number" visible={false} />
                <Column dataField="plannedReceivedShippedDateTime" caption="Planned Received/Shipped Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="amount" caption="Amount" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="actualReceivedShippedDateTime" caption="Actual Received/Shipped Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="equipmentInterchangeReport" caption="Equipment Interchange Report" visible={false} />
                <Column dataField="container" caption="Container" visible={false} />
                <Column dataField="reference" caption="Reference" visible={false} />
                <Column dataField="truckReference" caption="Truck Reference" visible={false} />
                <Column dataField="truckArrivalDateTime" caption="Truck Arrival Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="truckDepartDateTime" caption="Truck Depart Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="deliveryPickupFlag" caption="Delivery Pickup" visible={false} />
                <Column dataField="deliveryPickupDepartDateTime" caption="Delivery Pickup Depart Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="dispatchOrderNumber" caption="Dispatch Order#" visible={false} />
                <Column dataField="thirdPartyBillType" caption="Third Party Bill Type" visible={false} />
                <Column dataField="consolidateInvoiceFlag" caption="Consolidate" visible={false} />
                <Column dataField="pickStatus" caption="Pick Status" visible={false} />
                <Column dataField="freightChargeType" caption="Freight Charge Type" visible={false} />
                <Column dataField="freightAmount" caption="Freight Amount" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="codAmount" caption="COD Amount" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="codAmountCollected" caption="COD Amount Collected" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="codCollectionDateTime" caption="COD Collection Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="codPayMethod" caption="COD Pay Method" visible={false} />
                <Column dataField="taxBasis" caption="Tax Basis" visible={false} />
                <Column dataField="taxRate" caption="Tax Rate" dataType="number" visible={false} />
                <Column dataField="taxAmount" caption="Tax Amount" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="printReceipt" caption="Print Receipt" visible={false} />
                <Column dataField="printBol" caption="Print BOL" visible={false} />
                <Column dataField="printLabel" caption="Print Label" visible={false} />
                <Column dataField="sendFax" caption="Send Fax" visible={false} />
                <Column dataField="userDefinedCode1" caption="Code 1" visible={false} />
                <Column dataField="userDefinedCode2" caption="Code 2" visible={false} />
                <Column dataField="userDefinedCode3" caption="Code 3" visible={false} />
                <Column dataField="userDefinedCode4" caption="Code 4" visible={false} />
                <Column dataField="userDefinedCode5" caption="Code 5" visible={false} />
                <Column dataField="userDefinedCode6" caption="Code 6" visible={false} />
                <Column dataField="userDefinedCode7" caption="Code 7" visible={false} />
                <Column dataField="userDefinedCode8" caption="Code 8" visible={false} />
                <Column dataField="userDefinedCode9" caption="Code 9" visible={false} />
                <Column dataField="userDefinedCode10" caption="Code 10" visible={false} />
                <Column dataField="userDefinedReference1" caption="Reference 1" visible={false} />
                <Column dataField="userDefinedReference2" caption="Reference 2" visible={false} />
                <Column dataField="userDefinedReference3" caption="Reference 3" visible={false} />
                <Column dataField="userDefinedReference4" caption="Reference 4" visible={false} />
                <Column dataField="userDefinedReference5" caption="Reference 5" visible={false} />
                <Column dataField="userDefinedReference6" caption="Reference 6" visible={false} />
                <Column dataField="userDefinedReference7" caption="Reference 7" visible={false} />
                <Column dataField="userDefinedReference8" caption="Reference 8" visible={false} />
                <Column dataField="userDefinedReference9" caption="Reference 9" visible={false} />
                <Column dataField="userDefinedReference10" caption="Reference 10" visible={false} />
                <Column dataField="userDefinedDate1" dataType="date" format="MM/dd/yyyy" caption="Date 1" visible={false} />
                <Column dataField="userDefinedDate2" dataType="date" format="MM/dd/yyyy" caption="Date 2" visible={false} />
                <Column dataField="userDefinedDate3" dataType="date" format="MM/dd/yyyy" caption="Date 3" visible={false} />
                <Column dataField="userDefinedDate4" dataType="date" format="MM/dd/yyyy" caption="Date 4" visible={false} />
                <Column dataField="userDefinedDate5" dataType="date" format="MM/dd/yyyy" caption="Date 5" visible={false} />
                <Column dataField="userDefinedDate6" dataType="date" format="MM/dd/yyyy" caption="Date 6" visible={false} />
                <Column dataField="userDefinedDate7" dataType="date" format="MM/dd/yyyy" caption="Date 7" visible={false} />
                <Column dataField="userDefinedDate8" dataType="date" format="MM/dd/yyyy" caption="Date 8" visible={false} />
                <Column dataField="userDefinedDate9" dataType="date" format="MM/dd/yyyy" caption="Date 9" visible={false} />
                <Column dataField="userDefinedDate10" dataType="date" format="MM/dd/yyyy" caption="Date 10" visible={false} />
                <Column dataField="userDefinedQuantity1" dataType="number" caption="Quantity 1" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="userDefinedQuantity2" dataType="number" caption="Quantity 2" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="userDefinedQuantity3" dataType="number" caption="Quantity 3" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="userDefinedQuantity4" dataType="number" caption="Quantity 4" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="userDefinedQuantity5" dataType="number" caption="Quantity 5" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="userDefinedQuantity6" dataType="number" caption="Quantity 6" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="userDefinedQuantity7" dataType="number" caption="Quantity 7" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="userDefinedQuantity8" dataType="number" caption="Quantity 8" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="userDefinedQuantity9" dataType="number" caption="Quantity 9" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="userDefinedQuantity10" dataType="number" caption="Quantity 10" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} visible={false} />
                <Column dataField="planAppointmentComment" caption="Plan Apntmnt Comment" visible={false} />
                <Column dataField="fiscalYear" dataType="number" caption="FY" visible={false} />
                <Column dataField="fiscalPeriod" dataType="number" caption="FP" visible={false} />
                <Column dataField="commitDate" dataType="date" format="MM/dd/yyyy" caption="Commit Date" visible={false} />
                <Column dataField="holdReason" caption="Hold Reason" visible={false} />
                <Column dataField="consolidatedInvoice" caption="Invoice Code" visible={false} />
                <Column dataField="transferToDispatch" caption="Transfer To Dispatch" visible={false} />
                <Column dataField="transactionGroup" caption="Transaction Group" visible={false} />
                <Column dataField="fmTruckReference" caption="FM Truck Reference" visible={false} />
                <Column dataField="fmTrailerReference" caption="FM Trailer Reference" visible={false} />
                <Column dataField="fmDriverReference" caption="FM Driver Reference" visible={false} />
                <Column dataField="transportationYardLeaveDate" dataType="date" format="MM/dd/yyyy" caption="Transportation Yard Leave Date" visible={false} />
                <Column dataField="carrier" caption="Carrier" visible={false} />
                <Column dataField="carrierName" caption="Carrier Name" visible={false} />
                <Column dataField="transportCarrier" caption="Transport Carrier" visible={false} />
                <Column dataField="transportCarrierName" caption="Transport Carrier Name" visible={false} />
                <Column dataField="deliverypickupplanneddatetime" caption="Plan Apntmnt From" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="deliverypickuparrivedatetime" caption="Plan Apntmnt To" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="planresourcescode" caption="Plan Apntmnt Rsrc" visible={false} />
                <Column dataField="planresourceshours" caption="Plan Apntmnt Rsrc Hrs" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="planreference" caption="Plan Apntmnt Ref" visible={false} />
                <Column dataField="plancomment" caption="Plan Comment" visible={false} />
                <Column dataField="stagingWH" caption="Staging WH" visible={false} />
                <Column dataField="stagingWHName" caption="Staging WH Name" visible={false} />
                <Column dataField="planWH" caption="Plan WH" visible={false} />
                <Column dataField="planWHName" caption="Plan WH Name" visible={false} />
                <Column dataField="stagingArea" caption="Staging Area" visible={false} />
                <Column dataField="receivedshippeddatetime" caption="Staging Planned" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="stagingStartDt" caption="Staging Start Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="stagingFinishDt" caption="Staging Finish Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="assgndUnloadedBy" caption="Assigned Unloaded By" visible={false} />
                <Column dataField="assgndUnloadedPlnDt" caption="Assigned Unloaded Planned Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="assgndCheckBy" caption="Assigned Check By" visible={false} />
                <Column dataField="assgndCheckByDt" caption="Assigned Check By Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="putAwayBy" caption="Put Away By" visible={false} />
                <Column dataField="assgndPutAwayByDt" caption="Assigned Put Away By Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="dockYardWH" caption="Dock Yard WH" visible={false} />
                <Column dataField="dockYardLoc" caption="Dock Yard Location" visible={false} />
                <Column dataField="department" caption="Department" visible={false} />
                <Column dataField="departmentDescription" caption="Department Description" visible={false} />
                <Column dataField="job" caption="Job" visible={false} />
                <Column dataField="jobDescription" caption="Job Description" visible={false} />
                <Column dataField="fund" caption="Fund" visible={false} />
                <Column dataField="fundDescription" caption="Fund Description" visible={false} />
                <Column dataField="transportDriverID" caption="Transport Driver ID" visible={false} />
                <Column dataField="transportDriverName" caption="Transport Driver Name" visible={false} />
                <Column dataField="transportTrailerID" caption="Transport Trailer ID" visible={false} />
                <Column dataField="transportTruckID" caption="Transport Truck ID" visible={false} />
                <Column dataType="string" visible={false} dataField="editransmitShipper" caption="EDI Transmit Shipper">
                    <Lookup dataSource={cariers} displayExpr="name" valueExpr="id" />
                </Column>
                <Column dataType="string" visible={false} dataField="editransmitConsignee" caption="EDI Transmit Consignee">
                    <Lookup dataSource={cariers} displayExpr="name" valueExpr="id" />
                </Column>
                <Column dataType="string" visible={false} dataField="editransmitCarrier" caption="EDI Transmit Carrier">
                    <Lookup dataSource={cariers} displayExpr="name" valueExpr="id" />
                </Column>
                <Column dataType="string" visible={false} dataField="editransmitCustomer" caption="EDI Transmit Customer">
                    <Lookup dataSource={cariers} displayExpr="name" valueExpr="id" />
                </Column>
                <Column dataField="deliveryPickupPlannedDateTime" caption="Delivery Pickup Planned Date Time" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="planDock" caption="Plan Apntmnt Dock" visible={false} />
                <Column dataField="delAppointmentReference" caption="Delivery Reference" visible={false} />
                <Column dataField="delAppointmentDt" caption="Delivery Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="trackingNumber" caption="Tracking Number" visible={false} />


                <Toolbar>

                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(HistoryTransaction);